<template>
  <a-icon
    v-bind="$attrs"
    :icon="$attrs.icon || ICON.SOCIAL_SQUARE_LEARN_TERM"
    :title="title"
    :disabled="isIconDisabled"
    :original="true"
    :to="generateTermRoute(term)"
  />
</template>

<script>
import { pathOr } from 'ramda'

import AIcon, { ICON } from 'shared/AIcon'
import { propValidator, PROP_TYPES } from '@/utils/validators'
import mixins from '@/utils/mixins'

export default {
  name: 'LearnAboutTerm',
  mixins: [mixins.urlGenerators],
  inheritAttrs: false,
  components: { AIcon },
  props: {
    term: propValidator([PROP_TYPES.OBJECT], false)
  },
  data() {
    return { ICON }
  },
  computed: {
    processedTerm() {
      return this.$helper.processResponse(this.term)
    },
    title() {
      return `Learn about ${pathOr('', ['name'], this.processedTerm)}`
    },
    isIconDisabled() {
      return !this.processedTerm || !this.processedTerm.slug
    }
  }
}
</script>
